import { BaseContainerRuntimeFactory, DataObjectFactory } from '@fluidframework/aqueduct';
import { ConsensusRegisterCollection } from '@fluidframework/register-collection';
import { IContainerRuntime } from '@fluidframework/container-runtime-definitions';
import { MfsFluidDataStore } from './mfsFluidDataStore';
import { SharedTree, WriteFormat } from '@fluid-experimental/tree';
import { rootDataStoreRequestHandler } from '@fluidframework/request-handler';
import { MfsFluidSystemDataStore } from './mfsFluidSystemDataStore';

export const MFS_DATA_STORE_ID = 'dataStore';
export const MFS_VOLATILE_SESSION_ID = 'volatileSession';

const MfsFluidDataStoreFactory = new DataObjectFactory(
  '@metaos/mfs-tree',
  MfsFluidDataStore,
  // Don't summarize history, there's no way to delete it today and therefore we may lose compliance if we save it.
  [SharedTree.getFactory(WriteFormat.v0_1_1, undefined), ConsensusRegisterCollection.getFactory()],
  {},
  []
);

const MfsFluidVolatileSessionFactory = new DataObjectFactory(
  '@metaos/mfs-volatile-session',
  MfsFluidSystemDataStore,
  [],
  {},
  []
);

const registryEntries = new Map([MfsFluidDataStoreFactory.registryEntry, MfsFluidVolatileSessionFactory.registryEntry]);

class MfsRuntimeFactory extends BaseContainerRuntimeFactory {
  constructor() {
    super(registryEntries, undefined, [rootDataStoreRequestHandler]);
  }

  /** {@inheritDoc BaseContainerRuntimeFactory.containerInitializingFirstTime} */
  protected async containerInitializingFirstTime(runtime: IContainerRuntime) {
    const fluidDataStore = await runtime.createDataStore(MfsFluidDataStoreFactory.type);
    await fluidDataStore.trySetAlias(MFS_DATA_STORE_ID);
    const volatileSessionDataStore = await runtime.createDataStore(MfsFluidVolatileSessionFactory.type);
    await volatileSessionDataStore.trySetAlias(MFS_VOLATILE_SESSION_ID);
  }
}

export const MfsContainerFactory = new MfsRuntimeFactory();
